import { render } from "./LogicValueAssignmentsRoute.vue?vue&type=template&id=da38e0e2&scoped=true"
import script from "./LogicValueAssignmentsRoute.vue?vue&type=script&lang=js"
export * from "./LogicValueAssignmentsRoute.vue?vue&type=script&lang=js"

import "./LogicValueAssignmentsRoute.vue?vue&type=style&index=0&id=da38e0e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da38e0e2"]])

export default __exports__